/*
 * Layout
 * @module features/App
 * @flow weak
 */

import {
  compose,
  lifecycle,
  pure,
  withHandlers,
  withPropsOnChange,
  withStateHandlers,
} from 'recompose';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { stringify } from 'query-string';

import { withSettings } from '~/features/App/Settings';
import { withDevice } from '~/features/App/Device';
import { withViewer } from '~/features/App/Viewer';
import { AceService } from '~/services';

import { Layout as LTC } from './Layout';
import messages from './messages';

const setManifest = locale => {
  const manifest = document.querySelector('link[rel=manifest]');

  if (manifest) {
    manifest.setAttribute(
      'href',
      `/manifest${locale === 'zh-CN' ? '.zh' : ''}.json`,
    );
  }
};

const enhance = compose(
  withDevice,
  withSettings,
  withViewer,
  injectIntl,
  withRouter,
  withPropsOnChange(['mutate', 'settings'], ({ intl }) => {
    document.title = intl.formatMessage(messages.title);
    setManifest(intl.locale);

    return {};
  }),
  withStateHandlers(
    {
      isBottomBarVisible: true,
      isModalVisible: false,
      screenHeight: null,
      screenOrientation: null,
    },
    {
      toggleModal: state => () => ({
        ...state,
        isModalVisible: !state.isModalVisible,
      }),
      updateState: state => newState => ({
        ...state,
        ...newState,
      }),
    },
  ),
  withHandlers({
    onScreenResize: ({
      isBottomBarVisible,
      orientation,
      screenHeight,
      screenOrientation,
      updateState,
    }) => () => {
      if (screenOrientation === orientation) {
        updateState({
          isBottomBarVisible: screenHeight
            ? window.innerHeight === screenHeight
            : true,
          screenHeight: screenHeight || window.innerHeight,
        });

        return;
      }

      updateState({
        screenHeight: isBottomBarVisible ? window.innerHeight : null,
        screenOrientation: orientation,
      });
    },
    redirectToArchivedTransactions: ({ history }) => () => {
      history.push('/archived-transactions');
    },
    redirectToGRC: ({ locale }) => () => {
      window.location.href = `${
        // $FlowIssue
        process.env.REACT_APP_LANDING_ENDPOINT
      }/?${stringify({
        locale,
      })}`;
    },
    signOut: () => () => AceService.signOut(),
  }),
  lifecycle({
    componentDidMount() {
      const { orientation, onScreenResize, updateState } = this.props;

      updateState({
        screenHeight: window.innerHeight,
        screenOrientation: orientation,
      });
      window.addEventListener('resize', onScreenResize);
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.onScreenResize);
    },
  }),
  pure,
);

export const Layout = enhance(LTC);
